module.exports = __webpack_public_path__ + "media/images/flags/sv-4984ae470ed69178af1dc26d6978f38f.svg";